module.exports = __webpack_public_path__ + "static/media/A.f2a5d5c0.svg";